// Wave 3.99ai — "Active-sense" display labels for production stages, shown
// ONLY inside the SLA / notify CONFIGURATION screens:
//   • Manage SLA Template dialog (Production Timeline)
//   • New Order form → Configure SLA (draft)
//   • Order Detail → Edit Production SLA (existing)
//
// Why: a stage's notification fires when it becomes ACTIVE (ready to be
// worked on), NOT when it is "Confirmed" (completed). The canonical labels
// (e.g. "CAD Confirmed") stay UNCHANGED everywhere else — the timeline board,
// the production checklist, order PDFs and stored data. This is purely a
// clarity override in the config UIs so operators understand the notify/SLA
// timing. Material procurement rows (Gold/Diamond/…) are intentionally left
// as-is (they already read as in-progress tasks).
const ACTIVE_SENSE_BY_KIND = {
  cad_confirmed: 'CAD Active',
  cam_confirmed: 'CAM Active',
  chamka_issued: 'Chamka Active',
  ghat_confirmed: 'Ghat Active',
};

export function slaConfigStageLabel(kind, fallbackLabel) {
  return ACTIVE_SENSE_BY_KIND[kind] || fallbackLabel || kind || '';
}
